import React from 'react';
import PropTypes from 'prop-types';
import CheckboxPanel from './checkbox-panel';
import { hasValue } from '../../../general/js/general-helpers';
import gtm, { ecommerceEventTypes } from '../../../general/js/gtm';
import { CURRENCY_RATIO, currencyIsoCodes } from '../../../general/js/basket/currency-helper';

export default class ProductGroupPanel extends React.Component {
    constructor(props) {
        super(props);

        this.onClick = this.onClick.bind(this);
    }

    onClick() {
        this.props.onSelect(this.props.productGroup.id);

        if (!this.props.productGroup.isSelected) {
            const productGroup = this.props.productGroup;
            const product = productGroup.products[0];
            const productPrice = product.price / CURRENCY_RATIO;

            gtm.pushEcommerceEvent(ecommerceEventTypes.SELECT_ITEM, {
                currency: currencyIsoCodes.GBP,
                value: productPrice,
                items: [
                    {
                        item_id: product.productId,
                        item_name: `${product.tag} - ${productGroup.title}`,
                        price: productPrice,
                        quantity: 1,
                    }
                ]
            });
        }
    }

    getProductGroupTag() {
        if (!hasValue(this.props) && !hasValue(this.props.productGroup)) return null;

        const { productGroup: { productTag }, productGroup: { isSoldOut } } = this.props;

        if (!hasValue(productTag) || isSoldOut) return null;

        const { title, backgroundColor, textColor } = productTag;

        if (!hasValue(title)) return null;

        return {
            title: title,
            backgroundColor: backgroundColor,
            textColor: textColor
        };
    }

    renderProductGroupTag() {
        const productTag = this.getProductGroupTag();

        if (!hasValue(productTag)) return null;

        const { title, backgroundColor, textColor } = productTag;

        const inlineTagStyle = hasValue(backgroundColor) || hasValue(textColor)
            ? { backgroundColor: backgroundColor, color: textColor }
            : {};

        return (
            <div className="product-panel__product-group-tag"
                style={inlineTagStyle}>
                {title}
            </div>
        );
    }

    renderButton() {
        if (this.props.productGroup.isComplete) {
            return (
                <div className="product-panel__in-basket copy">These tickets already added to <a
                    href="/ticketbuilder/basket">basket</a></div>
            );
        }

        return null;
    }

    render() {
        const productGroup = this.props.productGroup;

        const stateCssClass = [];
        const rootCssModificator = [];
        const productGroupTag = this.getProductGroupTag();

        if (productGroup.useBlueHighlight) {
            rootCssModificator.push('product-panel--bundle');
        }

        if (!productGroup.isComlete && !productGroup.isSoldOut && hasValue(productGroupTag)) {
            rootCssModificator.push('product-panel--product-group-tag');
        }

        if (productGroup.isSoldOut) {
            stateCssClass.push('is-sold-out');
        }

        if (productGroup.isComlete) {
            stateCssClass.push('is-complete');
        }
        const isDisabled = productGroup.isComlete || productGroup.isSoldOut;

        const classes = `${rootCssModificator.join(' ')} ${stateCssClass.join(' ')}`;

        return (
            <CheckboxPanel cssClasses={classes}
                isSelected={productGroup.isSelected}
                isDisabled={isDisabled}
                soldOutLabel={productGroup.soldOutLabel}
                title={productGroup.title}
                text={productGroup.summaryText}
                bracketsText={productGroup.bracketsText}
                button={this.renderButton()}
                additional={this.renderProductGroupTag()}
                onClick={this.onClick} />
        );
    }
}

ProductGroupPanel.propTypes = {
    productGroup: PropTypes.object,
    onSelect: PropTypes.func,
};
